'use strict';

let versionCheck = function (pmtEnvService) {
	let that = this;
	that.isCurrentVersion = true;

	let baseUrl = pmtEnvService.listingsManagerUrl.replace('https', 'wss').replace('/listings/', '/');
	let socketUrl = baseUrl + 'version';

	let version = io.connect(socketUrl, { transports: ['websocket'], path: '/listings/socket.io' });

	version.on('version', function (data) {
		that.isCurrentVersion = window.pmtVersionCheckHash ? window.pmtVersionCheckHash === data : true;
	});
};

angular.module('PinMeTo.versionCheck', []);
angular.module('PinMeTo.versionCheck').service('pmtVersionCheck', ['pmtEnvService', versionCheck]);
